import { updateType } from "keys"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { actions } from "store"

const useOmission = () => {
    const dispatch = useDispatch()
    const { words } = useSelector(state => state.words)

    const removeWord = (index) => {
        let nWord = { ...words[index] }
        nWord.removed = !nWord.removed

        // בסימון של הסרה אנחנו מנהלים את מילוי השדה סטטוס לא בפונקצייה הזו
        
        // :ישנם שלושה סוגי הסרות
        // הסרה מינימלית - צובעת בכחול לבד - לא נחשבת כשגיאה
        // הסרה עם שגיאה - כחול + אדום - נחשבת כשגיאה
        // הסרה עם שגיאה קלה - כחול + כתום - נחשבת כשגיאה רק לחישוב דיוק גולמי
       
        nWord.customStatus = false
        nWord.update_type = updateType.update
        dispatch(actions.updateSingleWord({ index: index, word: nWord }))
    }

    return removeWord
}

export default useOmission